// A back/forward cache restore keeps React state, so anything the outbound
// click set (like an "is updating" spinner) is still there on the way back.
// `pageshow` with `persisted` set is the only signal for that restore.
export function onBfcacheRestore (handler) {
  const listener = (event) => { if (event.persisted) handler() }

  window.addEventListener('pageshow', listener)

  return () => window.removeEventListener('pageshow', listener)
}
